module.exports = __webpack_public_path__ + "packs/media/images/Warum_MM-6a5f24488383e121f7994b5dc7b706eb.jpg";